/**
 * Generated by orval v6.16.0 🍺
 * Do not edit manually.
 * Neubie Order
 * Neubie Order API Server
 * OpenAPI spec version: V1
 */

/**
 * * `PG` - PG사 수수료로 자동 정산
 * `MANUAL` - 수동 정산
 */
export type SettlementContractTypeEnum = (typeof SettlementContractTypeEnum)[keyof typeof SettlementContractTypeEnum]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettlementContractTypeEnum = {
  PG: 'PG',
  MANUAL: 'MANUAL'
} as const
